import { useMemo } from "react";
import useRecord from "../../api/api-hooks/records/useRecord";
import { DrawerProps } from "./DrawerTypes";
import CreateRecordDrawer from "./Records/CreateRecordDrawer";
import { Prefill } from "../../types/GlobalInterfaces";
import { Module } from "../../types/TenantInterfaces";

interface Props extends DrawerProps {
  recordID: string;
  moduleAPIName: string;
  crdProps: any; // Create record drawer props from Parent
  module?: Module | null;
  resetSelected: () => void;
}

const emptyPrefill: Prefill[] = [];

export default function DuplicateRecordDrawer({
  open,
  onClose,
  recordID,
  moduleAPIName,
  module,
  resetSelected,
  crdProps,
}: Props) {
  const { record, recordLoading } = useRecord({ moduleAPIName, recordID });

  const duplicationPrefill = useMemo(() => {
    if (!record || recordLoading) return null;

    return Object.keys(record).reduce((arr: any, key) => {
      if (!record[key] && typeof record[key] !== "boolean") {
        return arr;
      }

      arr.push({ Field: key, Value: record[key] });
      return arr;
    }, []);
  }, [record, recordLoading]);

  return (
    <CreateRecordDrawer
      loading={recordLoading || !duplicationPrefill}
      open={open}
      onClose={onClose}
      moduleAPIName={moduleAPIName}
      {...crdProps}
      originalRecord={record}
      prefill={duplicationPrefill || emptyPrefill}
      onCreate={() => {
        onClose();
        resetSelected();
      }}
      isDuplicate
    />
  );
}
